/**
 * VideoMessageCapture — canonical name for the booth's video / audio
 * message capture flow. Explicit import + default re-export so the
 * bundler resolves the symbol deterministically.
 */
import BoothVideoMessage from './BoothVideoMessage';
export default BoothVideoMessage;
